import React, { useEffect, useState } from "react";
import Form from 'react-bootstrap/Form';
import "./employeesurveys.css";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAuth } from "../../../firebase/AuthProvider";
import { Link, useNavigate, useParams } from "react-router-dom";
import {  GetSurveyResponseAsync, SaveServeyResponse } from "../../../services/surveyService/SurveyService";
import { EmergencyEventDto } from "../../../interfaces/survey/SurveyDtos";
import backarrowbtn from '../../../assets/images/backarrowbtn.svg'

// Define the survey data type
type SurveyData = {
    impact: string; // 1. I feel my work has made a tangible impact...
    proud: string; // 2. I see the outcomes of my work...
    connectGoals: string; // 3. I understand how my daily tasks connect...
    prideCoordinator: string; // 4. I feel pride in being a Support Coordinator
    burnout: string; // 5. How often did you feel burned out...
    supervisorAccessible: string; // 1. My supervisor has been accessible...
    feedback: string; // 2. I receive constructive, helpful feedback...
    psychSafety: string; // 3. I feel psychologically safe...
    agencyCulture: string; // 4. Our agency promotes a culture...
    caseloadManageable: string; // 1. My caseload was manageable...
    systemsEfficient: string; // 2. The systems I use...
    timeActivities: string[]; // 3. I spend an appropriate amount of time...
    auditConfidence: string; // 4. How confident did you feel...
    skillOpportunities: string; // 1. I had meaningful opportunities...
    growthPath: string; // 2. I see a clear path for advancement...
    motivatedStay: string; // 3. I feel motivated to stay...
    engagedValued: string; // 4. I’m engaged, see future opportunities...
    leavingFactors: string; // 5. If you have considered leaving...
    recommendAgency: string; // 6. How likely are you to recommend...
    thrive: string; // 1. What helped you thrive...
    barriers: string; // 2. What barriers made your job harder...
    magicWand: string; // 3. If you could wave a magic wand...
    engagementHelp: string[]; // 4. What would help you feel more engaged...
    anythingElse: string; // 5. Is there anything else you'd like to share?
};

// Initial state with meaningful keys
const initialSurveyData: SurveyData = {
    impact: "",
    proud: "",
    connectGoals: "",
    prideCoordinator: "",
    burnout: "",
    supervisorAccessible: "",
    feedback: "",
    psychSafety: "",
    agencyCulture: "",
    caseloadManageable: "",
    systemsEfficient: "",
    timeActivities: [],
    auditConfidence: "",
    skillOpportunities: "",
    growthPath: "",
    motivatedStay: "",
    engagedValued: "",
    leavingFactors: "",
    recommendAgency: "",
    thrive: "",
    barriers: "",
    magicWand: "",
    engagementHelp: [],
    anythingElse: ""
};

const Employeesurveys: React.FC = () => {
    const [currentStep, setCurrentStep] = useState<number>(1);
    const [answers, setAnswers] = useState<SurveyData>(initialSurveyData);
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const { instanceId } = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [authToken, setAuthToken] = useState<string>();
    const [isAlreadyFilled, setIsAllreadyFilled] = useState<boolean>(false);

    useEffect(() => {
        currentUser?.getIdToken().then((token) => {
            if (token) {
                setAuthToken(token);
                if (instanceId) {
                    GetSurveyResponse(token, instanceId);
                    // GetSurveyDetailsByInstanceId(token, instanceId);
                }
            }
        })
    }, []);

    // const GetSurveyDetailsByInstanceId = (token: string, instance_Id: string) => {
    //     GetSurveyDetailsbyInstanceIdAsync(token, instance_Id).then((res) => {
    //         if (res.success) {
    //             setSurveyDetails(res.data);
    //         } else {
    //             toast.error(res.message);
    //         }
    //     }).catch((err) => {
    //         toast.error(err.message);
    //     })
    // }

    const GetSurveyResponse = (token: string, instance_Id: string) => {
        setLoading(true);
        GetSurveyResponseAsync(token, instance_Id).then((res) => {
            if (res.success) {
                const surveyData = JSON.parse(res.data.responseData);
                setAnswers(surveyData);
                setIsAllreadyFilled(true);
            }
        }).finally(() => {
            setLoading(false);
        })
    }


    // Helper to update radio answers using key
    const handleRadioChange = (key: keyof SurveyData, value: string) => {
        setAnswers(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // Helper to update text answers using key
    const handleTextChange = (key: keyof SurveyData, value: string) => {
        setAnswers(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // Helper to update checkbox answers using key
    const handleCheckboxChange = (key: keyof SurveyData, value: string, checked: boolean) => {
        setAnswers(prev => {
            const prevArr = Array.isArray(prev[key]) ? prev[key] as string[] : [];
            if (checked) {
                return { ...prev, [key]: [...prevArr, value] };
            } else {
                return { ...prev, [key]: prevArr.filter((v: string) => v !== value) };
            }
        });
    };

    const validateSurvey = () => {
        if (currentStep == 1) {
            return (answers.impact && answers.proud && answers.connectGoals && answers.prideCoordinator && answers.burnout);
        } else if (currentStep == 2) {
            return (answers.supervisorAccessible &&
                answers.feedback &&
                answers.psychSafety &&
                answers.agencyCulture);
        }
        else if (currentStep == 3) {
            return (answers.caseloadManageable &&
                answers.systemsEfficient &&
                answers.timeActivities &&
                answers.auditConfidence);
        }
        else if (currentStep == 4) {
            return (answers.skillOpportunities &&
                answers.growthPath &&
                answers.motivatedStay &&
                answers.engagedValued &&
                answers.leavingFactors &&
                answers.recommendAgency);
        }
        else if (currentStep == 5) {
            return (answers.thrive &&
                answers.barriers &&
                answers.magicWand &&
                answers.engagementHelp &&
                answers.anythingElse);
        }

        return true
    }

    const handleClickNext = () => {
        if (!isAlreadyFilled && !validateSurvey()) {
            toast.error("Please Fill all the required Fields");
            return;
        }
        if (currentStep < 5) {
            setCurrentStep(currentStep + 1);
        } else {
            handleSubmit(); // at the last step will be submit
        }
    };

    const handleSubmit = () => {
        if (!authToken || !instanceId) return;
        if (!validateSurvey()) {
            toast.error("Please fill all required fields.");
            return;
        }
        setLoading(true);
        SaveServeyResponse(authToken, answers, instanceId).then((res) => {
            if (res.success) {
                toast.success(res.message);
                navigate(`/profile/notifications`)
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        }).finally(() => {
            setLoading(false);
        })
    };

    const handleClickPrevious = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    return (
        <>
            <div className="employee_surveys_container">
                <div className="top">
                    <div className="top_bar_tittle">
                        <h2> <Link to={'/profile/notifications'}>
                        <img src={backarrowbtn} alt="backarrowbtn"  /></Link> Employee Surveys</h2>
                    </div>
                </div>
                {/* Step 1 */}
                {currentStep === 1 && <div className="common_card">
                    <div className="top top_bar_flx">
                        <div className="top_bar_tittle">
                            <h2>Employee Surveys</h2>
                        </div>
                        <div className="step_form_count">
                            <p><span>Step 1 </span>/ 5</p>
                        </div>
                    </div>
                    <div className="step_form_flx">
                        <Form.Group className="step_form_grp" controlId="impact">
                            <Form.Label>1. I feel my work has made a tangible impact on the lives of participants this year.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`impact-${option}`}
                                        name="impact"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.impact === option}
                                        onChange={() => handleRadioChange("impact", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="proud">
                            <Form.Label>2. I see the outcomes of my work and feel proud of what I've contributed.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`proud-${option}`}
                                        name="proud"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.proud === option}
                                        onChange={() => handleRadioChange("proud", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="connectGoals">
                            <Form.Label>3. I understand how my daily tasks connect to larger goals and outcomes (e.g., compliance, participant independence).</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`connectGoals-${option}`}
                                        name="connectGoals"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.connectGoals === option}
                                        onChange={() => handleRadioChange("connectGoals", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="prideCoordinator">
                            <Form.Label>4. I feel pride in being a Support Coordinator</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`prideCoordinator-${option}`}
                                        name="prideCoordinator"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.prideCoordinator === option}
                                        onChange={() => handleRadioChange("prideCoordinator", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="burnout">
                            <Form.Label>5. How often did you feel burned out or emotionally exhausted from work this past year?</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`burnout-${option}`}
                                        name="burnout"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.burnout === option}
                                        onChange={() => handleRadioChange("burnout", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                    </div>
                    <div className="form_btn_flx mby_t_24">
                        <Button variant="primary" onClick={handleClickNext}>Next</Button>
                    </div>
                </div>}

                {/* Step 2 */}
                {currentStep === 2 && <div className="common_card">
                    <div className="top top_bar_flx">
                        <div className="top_bar_tittle">
                            <h2>Supervision & Feeling Supported</h2>
                        </div>
                        <div className="step_form_count">
                            <p><span>Step 2 </span>/ 5</p>
                        </div>
                    </div>
                    <div className="step_form_flx">
                        <Form.Group className="step_form_grp" controlId="supervisorAccessible">
                            <Form.Label>1. My supervisor has been accessible and responsive throughout the year.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`supervisorAccessible-${option}`}
                                        name="supervisorAccessible"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.supervisorAccessible === option}
                                        onChange={() => handleRadioChange("supervisorAccessible", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="feedback">
                            <Form.Label>2. I receive constructive, helpful feedback that supports my growth.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`feedback-${option}`}
                                        name="feedback"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.feedback === option}
                                        onChange={() => handleRadioChange("feedback", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="psychSafety">
                            <Form.Label>3. I feel psychologically safe bringing up concerns, mistakes, or burnout without fear of judgment.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`psychSafety-${option}`}
                                        name="psychSafety"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.psychSafety === option}
                                        onChange={() => handleRadioChange("psychSafety", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="agencyCulture">
                            <Form.Label>4. Our agency promotes a culture of collaboration, flexibility, and respect.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`agencyCulture-${option}`}
                                        name="agencyCulture"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.agencyCulture === option}
                                        onChange={() => handleRadioChange("agencyCulture", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                    </div>
                    <div className="form_btn_flx mby_t_24">
                        <Button variant="secondary" onClick={handleClickPrevious}>Prev</Button>
                        <Button variant="primary" onClick={handleClickNext}>Next</Button>
                    </div>
                </div>}

                {/* Step 3 */}
                {currentStep === 3 && <div className="common_card">
                    <div className="top top_bar_flx">
                        <div className="top_bar_tittle">
                            <h2>Supervision & Feeling Supported</h2>
                        </div>
                        <div className="step_form_count">
                            <p><span>Step 3 </span>/ 5</p>
                        </div>
                    </div>
                    <div className="step_form_flx">
                        <Form.Group className="step_form_grp" controlId="caseloadManageable">
                            <Form.Label>1. My caseload was manageable over the past year.</Form.Label>
                            <div className="check_list_flx">
                                {["Always", "Most of the time", "Sometimes", "Rarely", "Never"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`caseloadManageable-${option}`}
                                        name="caseloadManageable"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.caseloadManageable === option}
                                        onChange={() => handleRadioChange("caseloadManageable", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="systemsEfficient">
                            <Form.Label>2. The systems I use (e.g., documentation platform, state interfaces) are efficient and easy to use.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`systemsEfficient-${option}`}
                                        name="systemsEfficient"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.systemsEfficient === option}
                                        onChange={() => handleRadioChange("systemsEfficient", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="timeActivities">
                            <Form.Label>3. I spend an appropriate amount of time on the following activities: (Select all that apply)</Form.Label>
                            <div className="check_list_flx">
                                {[
                                    "Direct participant contact",
                                    "Documentation",
                                    "Resource navigation",
                                    "Peer collaboration / teaming",
                                    "Compliance / audit preparation",
                                    "Ongoing training / skill development",
                                    "None — my time is mostly spent on non-essential work"
                                ].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="checkbox"
                                        id={`timeActivities-${option}`}
                                        name="timeActivities"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={Array.isArray(answers.timeActivities) && answers.timeActivities.includes(option)}
                                        onChange={e => handleCheckboxChange("timeActivities", option, e.target.checked)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="auditConfidence">
                            <Form.Label>4. How confident did you feel navigating state audits or documentation requirements this year?</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Very confident", "Somewhat confident", "Neutral", "Somewhat stressed", "Very stressed"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`auditConfidence-${option}`}
                                        name="auditConfidence"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.auditConfidence === option}
                                        onChange={() => handleRadioChange("auditConfidence", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                    </div>
                    <div className="form_btn_flx mby_t_24">
                        <Button variant="secondary" onClick={handleClickPrevious}>Prev</Button>
                        <Button variant="primary" onClick={handleClickNext}>Next</Button>
                    </div>
                </div>}

                {/* Step 4 */}
                {currentStep === 4 && <div className="common_card">
                    <div className="top top_bar_flx">
                        <div className="top_bar_tittle">
                            <h2>Supervision & Feeling Supported</h2>
                        </div>
                        <div className="step_form_count">
                            <p><span>Step 4 </span>/ 5</p>
                        </div>
                    </div>
                    <div className="step_form_flx">
                        <Form.Group className="step_form_grp" controlId="skillOpportunities">
                            <Form.Label>1. I had meaningful opportunities to build my skills and knowledge this year.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`skillOpportunities-${option}`}
                                        name="skillOpportunities"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.skillOpportunities === option}
                                        onChange={() => handleRadioChange("skillOpportunities", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="growthPath">
                            <Form.Label>2. I see a clear path for advancement or growth within this agency.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`growthPath-${option}`}
                                        name="growthPath"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.growthPath === option}
                                        onChange={() => handleRadioChange("growthPath", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="motivatedStay">
                            <Form.Label>3. I feel motivated to stay at this agency for the next 12 months.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`motivatedStay-${option}`}
                                        name="motivatedStay"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.motivatedStay === option}
                                        onChange={() => handleRadioChange("motivatedStay", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="engagedValued">
                            <Form.Label>4. I’m engaged, see future opportunities, and feel valued here.</Form.Label>
                            <div className="check_list_flx">
                                {["Strongly Agree", "Agree", "Neutral", "Disagree", "Strongly Disagree"].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`engagedValued-${option}`}
                                        name="engagedValued"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.engagedValued === option}
                                        onChange={() => handleRadioChange("engagedValued", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="leavingFactors">
                            <Form.Label>5. If you have considered leaving, what are the primary factors?</Form.Label>
                            <div className="check_list_flx">
                                {[
                                    "Compensation",
                                    "Burnout or workload",
                                    "Lack of supervision/support",
                                    "Limited growth",
                                    "Stress from audits/state systems",
                                    "Tech inefficiencies",
                                    "Personal reasons",
                                    "I have not considered leaving"
                                ].map(option => (
                                    <Form.Check
                                        key={option}
                                        type="radio"
                                        id={`leavingFactors-${option}`}
                                        name="leavingFactors"
                                        label={option}
                                        className='check_with_label_two'
                                        checked={answers.leavingFactors === option}
                                        onChange={() => handleRadioChange("leavingFactors", option)}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                        <Form.Group className="step_form_grp" controlId="recommendAgency">
                            <Form.Label>6. How likely are you to recommend this agency as a great place to work to another Support Coordinator?</Form.Label>
                            <div className="check_list_flx">
                                {Array.from({ length: 11 }, (_, num) => num).map(num => (
                                    <Form.Check
                                        key={num}
                                        type="radio"
                                        id={`recommendAgency-${num}`}
                                        name="recommendAgency"
                                        label={num.toString()}
                                        className='check_with_label_two'
                                        checked={answers.recommendAgency === num.toString()}
                                        onChange={() => handleRadioChange("recommendAgency", num.toString())}
                                        disabled={isAlreadyFilled}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                    </div>
                    <div className="form_btn_flx mby_t_24">
                        <Button variant="secondary" onClick={handleClickPrevious}>Prev</Button>
                        <Button variant="primary" onClick={handleClickNext}>Next</Button>
                    </div>
                </div>}

                {/* Step 5 */}
                {currentStep === 5 &&
                    <div className="common_card">
                        <div className="top top_bar_flx">
                            <div className="top_bar_tittle">
                                <h2>Let Me Be Heard</h2>
                            </div>
                            <div className="step_form_count">
                                <p><span>Step 5 </span>/ 5</p>
                            </div>
                        </div>
                        <div className="step_form_flx">
                            <div className="row">
                                <div className="col-md-6">
                                    <Form.Group className="custom_input_flled" controlId="thrive">
                                        <Form.Label>1. What helped you thrive in your role this year?</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter"
                                            value={answers.thrive}
                                            onChange={e => handleTextChange("thrive", e.target.value)}
                                            disabled={isAlreadyFilled}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group className="custom_input_flled" controlId="barriers">
                                        <Form.Label>2. What barriers made your job harder than it needed to be?</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter"
                                            value={answers.barriers}
                                            onChange={e => handleTextChange("barriers", e.target.value)}
                                            disabled={isAlreadyFilled}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-12">
                                    <Form.Group className="custom_input_flled" controlId="magicWand">
                                        <Form.Label>3. If you could wave a magic wand and change one thing about your job, what would it be?</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter"
                                            value={answers.magicWand}
                                            onChange={e => handleTextChange("magicWand", e.target.value)}
                                            disabled={isAlreadyFilled}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="step_form_grp" controlId="engagementHelp">
                                    <Form.Label>4. What would help you feel more engaged, valued, or supported? (Select all that apply)</Form.Label>
                                    <div className="check_list_flx">
                                        {[
                                            "Reduced caseloads",
                                            "Better tech/tools",
                                            "More training",
                                            "Higher pay",
                                            "Peer collaboration",
                                            "Audit support",
                                            "Mental health/wellness",
                                            "Flexible scheduling"
                                        ].map(option => (
                                            <Form.Check
                                                key={option}
                                                type="checkbox"
                                                id={`engagementHelp-${option}`}
                                                name="engagementHelp"
                                                label={option}
                                                className='check_with_label_two'
                                                checked={Array.isArray(answers.engagementHelp) && answers.engagementHelp.includes(option)}
                                                onChange={e => handleCheckboxChange("engagementHelp", option, e.target.checked)}
                                                disabled={isAlreadyFilled}
                                            />
                                        ))}
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="custom_input_flled" controlId="anythingElse">
                                    <Form.Label>5. Is there anything else you'd like to share?</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter"
                                        value={answers.anythingElse}
                                        onChange={e => handleTextChange("anythingElse", e.target.value)}
                                        disabled={isAlreadyFilled}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        <div className="form_btn_flx mby_t_24">
                            <Button variant="secondary" onClick={handleClickPrevious}>Prev</Button>
                            {!isAlreadyFilled && <Button variant="primary" onClick={handleClickNext}>Finish</Button>}
                        </div>
                    </div>}
            </div >
        </>
    );
};

export default Employeesurveys;